import { motion } from "framer-motion";
import { ScrollReveal, StaggerParent, StaggerItem } from "@/components/shared/ScrollReveal";
import { useLang } from "@/i18n/LanguageContext";

export default function Manifesto() {
  const { t } = useLang();
  return (
    <section
      id="perche-noi"
      data-testid="manifesto-section"
      className="relative bg-[#050505] text-white py-28 md:py-40 border-t border-white/10 overflow-hidden scroll-mt-20"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-20">
          <ScrollReveal className="lg:col-span-8 lg:col-start-3">
            <p className="font-mono-eyebrow text-[var(--dp-accent)] mb-8 text-center">
              {t.manifesto.eyebrow}
            </p>
            <h2 className="font-display text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[0.95] tracking-tight text-center whitespace-pre-line">
              {t.manifesto.title.split("\n").map((line, i, arr) =>
                i === arr.length - 1 ? (
                  <span key={i} className="font-serif-italic text-[var(--dp-accent)]">
                    {line}
                    <br />
                  </span>
                ) : (
                  <span key={i}>
                    {line}
                    <br />
                  </span>
                )
              )}
            </h2>
          </ScrollReveal>
        </div>

        <StaggerParent className="max-w-4xl mx-auto">
          {t.manifesto.chapters.map((c, i) => (
            <StaggerItem key={c.n}>
              <motion.div
                data-testid={`manifesto-chapter-${i}`}
                className="grid grid-cols-12 gap-6 py-10 border-t border-white/10 group"
                whileHover="hover"
                initial="rest"
              >
                <motion.p
                  className="col-span-2 md:col-span-1 font-display text-3xl md:text-4xl text-[var(--dp-accent)] leading-none"
                  variants={{ rest: { x: 0 }, hover: { x: -6 } }}
                  transition={{ duration: 0.5 }}
                >
                  {c.n}
                </motion.p>
                <div className="col-span-10 md:col-span-11 grid grid-cols-1 md:grid-cols-12 gap-4">
                  <motion.h3
                    className="md:col-span-5 font-display text-2xl md:text-3xl lg:text-4xl leading-tight tracking-tight"
                    variants={{ rest: { x: 0 }, hover: { x: 6 } }}
                    transition={{ duration: 0.5 }}
                  >
                    {c.t}
                  </motion.h3>
                  <p className="md:col-span-7 text-neutral-400 text-base md:text-lg leading-relaxed">
                    {c.d}
                  </p>
                </div>
              </motion.div>
            </StaggerItem>
          ))}
        </StaggerParent>
      </div>
    </section>
  );
}
